import { createSlice } from "@reduxjs/toolkit";

export interface VisitorSlice {
  requestId?: string
}

const initialState: VisitorSlice = {}

export const visitorSlice = createSlice({
  name: 'visitor',
  initialState,
  reducers: {
    setReqeustId: (state, action) => {
      state.requestId = action.payload.requestId;
    }
  }
})

export default visitorSlice.reducer;

